import styled, { css } from 'styled-components'
import { FastResponderIcon } from '../../../common/icons'

export const OwnerInfoWrapper = styled.div(
    ({ theme }) => css`
        display: ${theme.style.display.flex};
        flex-direction: ${theme.style.flexDirection.column};
        padding: 0 ${theme.spacing.medium};
    `,
)

export const OwnerInfoContent = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    flex: 1;
    padding: ${({ theme }) => `${theme.spacing.small} 0`};
    padding-bottom: 0;
`

export const OwnerDetails = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.column};
    justify-content: ${({ theme }) => theme.style.justifyContent.center};
    flex: 1;
`

export const QuickResponderTag = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
    margin: 0.375rem 0;
    border-radius: 0.3125rem;
    background-color: #f9f5ff;
    color: #6b43a4;
    font-size: 0.6875rem;
    line-height: 1rem;
    font-weight: ${({ theme }) => theme.typography.font.weight.bold};
    width: fit-content;
`

export const StyledFastResponderIcon = styled(FastResponderIcon)`
    width: 0.8125rem;
    height: 0.8125rem;
    margin-right: 0.375rem;
    vertical-align: middle;
`
